import { createStore, applyMiddleware, compose, AnyAction } from "redux";
import rootReducer from "./reducers/RootReducer";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import signalRMiddleware from "./signalrMiddleware";
import { Dispatch } from "react";
import { composeWithDevTools } from 'redux-devtools-extension';

let dispatch: Dispatch<AnyAction> | null = null;

export function getDispatch(): Dispatch<AnyAction> {
  if (dispatch == null) {
    throw new Error("Dispatch is null");
  }
  return dispatch;
}

export default function configureStore() {
  if (process.env.NODE_ENV === "production") {
    const store = createStore(rootReducer, compose(applyMiddleware(thunk, signalRMiddleware)));
    dispatch = store.dispatch;
    return store;
  } else {
    const composeEnhancers = ((window as any)["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] as typeof compose) || compose;
    const store = createStore(
      rootReducer,
      // composeEnhancers(applyMiddleware(thunk, signalRMiddleware, reduxImmutableStateInvariant())) // Jansen ganti biar bisa pake ekstensi redux devtools
      composeWithDevTools(applyMiddleware(thunk, signalRMiddleware, reduxImmutableStateInvariant()))

    ); //don't forget to disable ths on production
    dispatch = store.dispatch;
    return store;
  }
}
